<template>
  <footer class="relative mt-20 md:mt-0">
    <div
      class="absolute right-0 bottom-[60px] flex w-full items-center px-5 2xl:px-[8%] ds:px-7"
    >
      <div
        data-test="made-with-text"
        class="block md:hidden relative text-caption"
      >
        {{ $t('auth.made_with') }}
        <img
          v-if="designSystem"
          :src="Vapor.asset('images/ds-illustrations/heart.svg')"
          alt="♥"
          class="inline-block size-4 -translate-y-px align-middle"
        />
        <FontAwesomeIcon
          v-else
          :icon="['fas', 'heart']"
          class="text-sm text-hue-magenta"
        />
        {{ $t('auth.on_earth') }}
      </div>
    </div>

    <div
      class="relative flex h-[55px] w-full items-center justify-between px-5 text-[9px] md:text-ui tracking-[0.2px] text-fg subpixel-antialiased shadow-[0_0_4px_rgb(15,34,58,0.12)] 2xl:px-[8%] bg-white ds:bg-transparent ds:px-7 ds:text-(length:--ds-font-size-xs) ds:tracking-normal ds:text-(--ds-text-secondary) ds:shadow-none"
    >
      <div
        data-test="year-airlst"
        class="flex flex-wrap items-center gap-y-2 gap-x-0.5 md:gap-x-1 relative whitespace-nowrap"
      >
        {{ new Date().getFullYear() }} ©
        <a
          aria-label="AirLST GmbH"
          target="_blank"
          rel="noopener"
          href="http://airlst.com/"
          class="hover:text-fg-ink"
          >AirLST GmbH</a
        >
        |
        <a
          target="_blank"
          class="hover:text-line-gray"
          :href="
            useSimplifiedCurrentLocale() === 'en'
              ? 'https://airlst.com/en-us/agb'
              : 'https://airlst.com/agb'
          "
          :aria-label="$t('auth.terms_of_use')"
        >
          {{ $t('auth.terms_of_use') }}
        </a>
        -
        <Link
          class="hover:text-line-gray"
          :href="useRoute('privacyPolicy', { locale: useCurrentLocaleCode() })"
          :aria-label="$t('auth.privacy_policy')"
        >
          {{ $t('auth.privacy_policy') }}
        </Link>
        -
        <Link
          class="hover:text-line-gray"
          :href="useRoute('imprint', { locale: useCurrentLocaleCode() })"
          :aria-label="$t('auth.legal_disclosure')"
        >
          {{ $t('auth.legal_disclosure') }}
        </Link>
        |
        <a
          class="hover:text-line-gray"
          href="https://airlst-suite.statuspage.io/"
          target="_blank"
          :aria-label="$t('auth.airlst_status')"
        >
          {{ $t('auth.airlst_status') }}
        </a>
      </div>

      <div data-test="made-with-text" class="hidden md:block relative">
        {{ $t('auth.made_with') }}
        <img
          v-if="designSystem"
          :src="Vapor.asset('images/ds-illustrations/heart.svg')"
          alt="♥"
          class="inline-block size-4 -translate-y-px align-middle"
        />
        <FontAwesomeIcon
          v-else
          :icon="['fas', 'heart']"
          class="text-sm text-hue-magenta"
        />
        {{ $t('auth.on_earth') }}
      </div>
    </div>
  </footer>
</template>

<script setup>
import Vapor from 'laravel-vapor'
import { useDesignSystem } from '@/composables/designSystem'
import { Link } from '@inertiajs/vue3'
import { useRoute } from '@/composables/route'
import {
  useCurrentLocaleCode,
  useSimplifiedCurrentLocale,
} from '@/composables/locale.js'

const designSystem = useDesignSystem()
</script>
